import { render, staticRenderFns } from "./Proccess.vue?vue&type=template&id=2d3f515f&scoped=true&"
import script from "./Proccess.vue?vue&type=script&lang=js&"
export * from "./Proccess.vue?vue&type=script&lang=js&"
import style0 from "./Proccess.vue?vue&type=style&index=0&id=2d3f515f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.8_eeqz4xtr3chsfpwu4zsrvzqhvy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3f515f",
  null
  
)

export default component.exports